import { createSlice } from '@reduxjs/toolkit';
import { productGalleryTitleDelete } from './productGalleryTitleAsyncThunk';

const productGalleryTitleDeleteSlice = createSlice({
  name: "productGalleryTitle",
  initialState: {
    isLoading: false,
    isSuccess: false,
    failCode: 0,
  },
  reducers: {},
  extraReducers: {
    [productGalleryTitleDelete.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.failCode = 0;
    },
    [productGalleryTitleDelete.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [productGalleryTitleDelete.rejected]: (state, action) => {
      state.isLoading = false;
      state.failCode = action.payload.status;
    },
  },
});

export default productGalleryTitleDeleteSlice.reducer;